import type { JSONLDParams } from './create-json-ld-object';

export const RECAPTCHA_SITE_KEY: string = import.meta.env.RECAPTCHA_SITE_KEY;
export const HOME_PAGE_JSON_LD: JSONLDParams = {
	pathname: '/',
	pagename: 'The 411 on Shipper Facilities™',
	type: 'WebPage',
	primaryImage: {
		url: 'https://dock411.com/logo.png',
		id: 'primaryImage'
	}
};
export const ABOUT_PAGE_JSON_LD: JSONLDParams = {
	pathname: '/about',
	pagename: 'About Dock411',
	type: 'WebPage',
	primaryImage: {
		url: 'https://dock411.com/logo.png',
		id: 'primaryImage'
	}
};
export const APP_PAGE_JSON_LD: JSONLDParams = {
	pathname: '/app',
	pagename: 'The App',
	type: 'WebPage',
	primaryImage: {
		url: 'https://dock411.com/logo.png',
		id: 'primaryImage'
	}
};
export const CLAIM_FACILITY_PAGE_JSON_LD: JSONLDParams = {
	pathname: '/claim-your-facility',
	pagename: 'Claim Your Facility',
	type: 'WebPage',
	primaryImage: {
		url: 'https://dock411.com/logo.png',
		id: 'primaryImage'
	}
};
export const CLAIM_FACILITY_IN_QUEUE_PAGE_JSON_LD: JSONLDParams = {
	pathname: '/claim-your-facility-its-in-the-queue',
	pagename: `Claim Your Facility - It's in the queue`,
	type: 'WebPage',
	primaryImage: {
		url: 'https://dock411.com/logo.png',
		id: 'primaryImage'
	}
};
export const CONTACT_PAGE_JSON_LD: JSONLDParams = {
	pathname: '/contact',
	pagename: `Contact Us`,
	type: 'WebPage',
	primaryImage: {
		url: 'https://dock411.com/logo.png',
		id: 'primaryImage'
	}
};
export const DOCK_DETAILS_PAGE_JSON_LD: JSONLDParams = {
	pathname: '/dock-details',
	pagename: `Dock Details`,
	type: 'WebPage',
	primaryImage: {
		url: 'https://dock411.com/logo.png',
		id: 'primaryImage'
	}
};
export const DOCK_411_FACILITY_PROFILES_PAGE_JSON_LD: JSONLDParams = {
	pathname: '/dock411-facility-profiles',
	pagename: `Dock411 Facility Profiles`,
	type: 'WebPage',
	primaryImage: {
		url: 'https://dock411.com/logo.png',
		id: 'primaryImage'
	}
};
export const OPENDOCK_PAGE_JSON_LD: JSONLDParams = {
	pathname: '/opendock-and-dock411-partnering-for-you',
	pagename: `OpenDock and Dock411 partnering for you`,
	type: 'WebPage',
	primaryImage: {
		url: 'https://dock411.com/logo.png',
		id: 'primaryImage'
	}
};
export const SHIPPERS_PAGE_JSON_LD: JSONLDParams = {
	pathname: '/shippers',
	pagename: `Shippers`,
	type: 'WebPage',
	primaryImage: {
		url: 'https://dock411.com/logo.png',
		id: 'primaryImage'
	}
};
export const STRATEGIC_SHIPPERS_PAGE_JSON_LD: JSONLDParams = {
	pathname: '/strategic-shippers-program',
	pagename: `Strategic shippers program`,
	type: 'WebPage',
	primaryImage: {
		url: 'https://dock411.com/logo.png',
		id: 'primaryImage'
	}
};
export const THE_411_PAGE_JSON_LD: JSONLDParams = {
	pathname: '/the-411',
	pagename: `The 411`,
	type: 'WebPage',
	primaryImage: {
		url: 'https://dock411.com/logo.png',
		id: 'primaryImage'
	}
};
export const BROKERS_PAGE_JSON_LD: JSONLDParams = {
	pathname: '/brokers',
	pagename: `Brokers`,
	type: 'WebPage',
	primaryImage: {
		url: 'https://dock411.com/logo.png',
		id: 'primaryImage'
	}
};
export const CARRIERS_PAGE_JSON_LD: JSONLDParams = {
	pathname: '/carriers',
	pagename: `Carriers`,
	type: 'WebPage',
	primaryImage: {
		url: 'https://dock411.com/logo.png',
		id: 'primaryImage'
	}
};
export const DRIVERS_PAGE_JSON_LD: JSONLDParams = {
	pathname: '/drivers',
	pagename: `Drivers`,
	type: 'WebPage',
	primaryImage: {
		url: 'https://dock411.com/logo.png',
		id: 'primaryImage'
	}
};
export const INSURANCE_COMPANIES_PAGE_JSON_LD: JSONLDParams = {
	pathname: '/insurance-companies',
	pagename: `Insurance Companies`,
	type: 'WebPage',
	primaryImage: {
		url: 'https://dock411.com/logo.png',
		id: 'primaryImage'
	}
};
export const USERS_PAGE_JSON_LD: JSONLDParams = {
	pathname: '/users',
	pagename: `Users`,
	type: 'WebPage',
	primaryImage: {
		url: 'https://dock411.com/logo.png',
		id: 'primaryImage'
	}
};
export const basePathJSONLDMapping: { [key: string]: JSONLDParams } = {
	'/': HOME_PAGE_JSON_LD,
	'/about': ABOUT_PAGE_JSON_LD,
	'/app': APP_PAGE_JSON_LD,
	'/claim-your-facility': CLAIM_FACILITY_PAGE_JSON_LD,
	'/claim-your-facility-its-in-the-queue': CLAIM_FACILITY_IN_QUEUE_PAGE_JSON_LD,
	'/contact': CONTACT_PAGE_JSON_LD,
	'/dock-details': DOCK_DETAILS_PAGE_JSON_LD,
	'/dock411-facility-profiles': DOCK_411_FACILITY_PROFILES_PAGE_JSON_LD,
	'/opendock-and-dock411-partnering-for-you': OPENDOCK_PAGE_JSON_LD,
	'/shippers': SHIPPERS_PAGE_JSON_LD,
	'/strategic-shippers-program': STRATEGIC_SHIPPERS_PAGE_JSON_LD,
	'/the-411': THE_411_PAGE_JSON_LD
};
export const sidebarPathJSONLDMapping: { [key: string]: JSONLDParams } = {
	'/brokers': BROKERS_PAGE_JSON_LD,
	'/carriers': CARRIERS_PAGE_JSON_LD,
	'/drivers': DRIVERS_PAGE_JSON_LD,
	'/insurance-companies': INSURANCE_COMPANIES_PAGE_JSON_LD
};
export const offersSteps: App.ProcessStep[] = [
	{
		name: 'signup',
		icon: 'person',
		text: 'Sign Up'
	},
	{
		name: 'payment',
		icon: 'currency-dollar',
		text: 'Payment'
	},
	{
		name: 'profiles',
		icon: 'building-fill-gear',
		text: 'Set Up Profiles'
	},
	{
		name: 'done',
		icon: 'check-circle',
		text: 'Done!'
	}
];
export const ALLOWED_ANONYMOUS_PROFILE_VIEWS = 3;
export const EMPTY_IMAGE_PLACEHOLDER = 'https://cdn.dock411.com/0000/images/no-image-available.jpg';
export const IMG_AVATAR_MALE = 'https://cdn.dock411.com/0000/avatars/male.png';
export const IMG_AVATAR_FEMALE = 'https://cdn.dock411.com/0000/avatars/female.png';
export const IMG_AVATAR_UNSPECIFIED = 'https://cdn.dock411.com/0000/avatars/unspecified.png';
export const REVIEWS_ITEMS = [
	{ item: 'cleanliness_rating', title: 'Cleanliness' },
	{ item: 'lighting_rating', title: 'Lighting' },
	{ item: 'lounge_rating', title: 'Lounge' },
	{ item: 'maneuverability_rating', title: 'Maneuverability' },
	{ item: 'parking_rating', title: 'Parking' },
	{ item: 'professionalism_rating', title: 'Professionalism' },
	{ item: 'restrooms_rating', title: 'Restrooms' },
	{ item: 'safety_rating', title: 'Safety' },
	{ item: 'security_rating', title: 'Security' },
	{ item: 'times_rating', title: 'Times' }
];
